import React, { useEffect } from 'react';
import { SpeedInsights } from "@vercel/speed-insights/react";
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import LiquidEther from './components/LiquidEther/LiquidEther';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

function App() {
  useEffect(() => {
    // Console welcome message
    console.log('%c Welcome to My Portfolio! ', 'background: #6366f1; color: #fff; font-size: 20px; padding: 10px;');
    console.log('%c Built with ❤️ using React, Framer Motion, and Tailwind CSS ', 'font-size: 14px; color: #6366f1;');
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        {/* Fixed liquid background - content scrolls over it */}
        <div className="liquid-bg-fixed">
          <LiquidEther
            mouseForce={18}
            cursorSize={120}
            isViscous={false}
            colors={["#FFFFFF", "#B8B8C0", "#6E6E78"]}
            autoDemo={true}
            autoSpeed={0.4}
            autoIntensity={1.6}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
        <Navbar />
        <main className="relative z-10">
          <Hero />
          <About />
          <Projects />
          <Contact />
        </main>
        <ScrollToTop />
        <SpeedInsights />
      </div>
    </ThemeProvider>
  );
}

export default App;
